module.exports = __webpack_public_path__ + "img/total_vehicle.a63f8e35.png";